import { render } from "./PractitionerSignaturePhaseDetermination.vue?vue&type=template&id=3914f8c2"
import script from "./PractitionerSignaturePhaseDetermination.vue?vue&type=script&lang=js"
export * from "./PractitionerSignaturePhaseDetermination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__